import { BUILDING_SHORT_LIST_API } from '../constants/api'
import { EMPTY_OBJECT } from '../constants/common'
import { BUILDING_ENTITY } from '../constants/entity'
import { deleteApi, getApi, patchApi, postApi } from '../utils/api'

export function getBuildingProfile(id) {
  return getApi({ endpoint: `api/v2/building/${id}/` })
}

export function updateBuildingProfile({ data, id }) {
  return patchApi({ data, endpoint: `api/v2/building/${id}/` })
}

export function removeBuildingFromBuildingGroups({ data, id }) {
  return deleteApi({
    data,
    endpoint: `api/${BUILDING_ENTITY.single}/${id}/building-groups/`,
  })
}

export function getFilteredBuildingsShortList(data) {
  return postApi({ data, endpoint: BUILDING_SHORT_LIST_API })
}

export function getBuildingsNG(params) {
  return getApi({
    endpoint: 'idwell-api/api/v3/construction/building-options/',
    params,
  })
}

export function searchBuildings({
  apiConfig = EMPTY_OBJECT,
  archived = false,
  query,
}) {
  return getApi({
    ...apiConfig,
    endpoint: `api/building/live-search/`,
    params: { ...apiConfig.params, archived, query },
  })
}

export function getBuildingLivingTypes(params) {
  return getApi({
    endpoint: 'api/living-type/',
    params,
  })
}

export function getBuildingInsurancesTypes(params) {
  return getApi({
    endpoint: 'api/insurance-type/',
    params,
  })
}

export function getBuildingInfo({ id, options }) {
  return getApi({ endpoint: `api/building/${id}/info`, options })
}

export function updateBuildingInfo({ data, id, options }) {
  return patchApi({ data, endpoint: `api/building/${id}/info`, options })
}

export function performBuildingsMassAction(data) {
  return postApi({
    data,
    endpoint: `idwell-api/api/v3/construction/${BUILDING_ENTITY.plural}/mass-action/`,
  })
}
